
export default function TestimonialsHero() {
  return (
    <section className="relative pt-32 pb-20 px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fa86203df71a1388c0339df496fd3397.jpg"
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative max-w-7xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-500/20 backdrop-blur-sm rounded-full mb-6">
          <i className="fas fa-star text-amber-400"></i>
          <span className="text-sm font-medium text-white">Trusted by 500+ Happy Customers</span>
        </div>

        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
          Customer Testimonials
        </h1>
        
        <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
          Discover what our satisfied customers have to say about their experience with Brushour. Real reviews from real projects across Hertfordshire and surrounding areas.
        </p>
      </div>
    </section>
  );
}
